import React, { useEffect, useRef, useState } from "react";
import "./CompanyAnnouncements.css";
import Testimonial from "../../../Testimonial/Testimonial";
import { Helmet } from "react-helmet";

const CompanyAnnouncement = () => {
  const techItemsRow1 = [
    { name: "Angular.js", logo: "/logos/angular.png" },
    { name: "HTML", logo: "/logos/html.png" },
    { name: "CSS3", logo: "/logos/css.png" },
    { name: "Bootstrap", logo: "/logos/bootstrap.png" },
    { name: "Javascript", logo: "/logos/javascript.png" },
    { name: "AmazonDB", logo: "/logos/amazon_dynamodb.png" },
    { name: "Appian", logo: "/logos/appian.png" },
    { name: "Laravel", logo: "/logos/laravel.png" },
    { name: "MariaDB", logo: "/logos/mariadb.png" },
    { name: "MongoDB", logo: "/logos/mongodb.png" },
    { name: "Android", logo: "/logos/android-5.png" },
    { name: "ERC-20", logo: "/logos/erc-20.png" },
    { name: "Ethereum", logo: "/logos/ethereum.png" },
    { name: "Flutter", logo: "/logos/flutter.png" },
    { name: "Ionic", logo: "/logos/ionic.png" },
    {
      name: "Artificial Intelligence",
      logo: "/logos/artificial-intelligence.png",
    },
    { name: "Augmented Reality", logo: "/logos/Augmented Reality.png" },
    { name: "Crda", logo: "/logos/crda.png" },
    { name: "Data Science", logo: "/logos/data-science.png" },
    { name: "Go Chain", logo: "/logos/gochain.png" },
  ];

  const techItemsRow2 = [
    { name: "Sass", logo: "/logos/saas.png" },
    { name: "JQuery", logo: "/logos/jquery.png" },
    { name: "Less", logo: "/logos/less.png" },
    { name: "Codeigniter", logo: "/logos/codeignitor.png" },
    { name: "Django", logo: "/logos/django.png" },
    { name: "Node JS", logo: "/logos/node js.png" },
    { name: "PHP", logo: "/logos/php.png" },
    { name: "Salesforce", logo: "/logos/salesforce.png" },
    { name: "SQL Server", logo: "/logos/sql-server.png" },
    { name: "MySQL", logo: "/logos/mysql-5.png" },
    { name: "IOS", logo: "/logos/ios.png" },
    { name: "Oracle 6", logo: "/logos/oracle.png" },
    { name: "PostgreSQL", logo: "/logos/postgresql.png" },
    { name: "React Native", logo: "/logos/react_native.png" },
    { name: "Solidity", logo: "/logos/Solidity.png" },
    { name: "Hyperledger", logo: "/logos/Hyperledger.png" },
    { name: "Internet Of Things", logo: "/logos/iot.png" },
    { name: "One Ledger", logo: "/logos/OneLedger.png" },
    { name: "Virtual Reality", logo: "/logos/virtual-reality.png" },
  ];

  const duplicatedRow1 = [...techItemsRow1, ...techItemsRow1];
  const duplicatedRow2 = [...techItemsRow2, ...techItemsRow2];

  const containerRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offset, setOffset] = useState(0);
  const animationRef = useRef();

  useEffect(() => {
    // Set initial container width
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollSpeed = 1; // Adjust speed as needed (pixels per frame)

    const animate = () => {
      setOffset((prevOffset) => {
        const maxOffset = row1Ref.current?.scrollWidth / 2 || 0;
        const newOffset = prevOffset + scrollSpeed;
        return newOffset >= maxOffset ? 0 : newOffset;
      });
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, [containerWidth]);

  return (
    <div>
      <Helmet>
        <title>
          Company Announcement Technology | Corporate Communication Platforms
        </title>
        <meta
          name="description"
          content="Advanced company announcement technology solutions including corporate communication platforms, investor relations tools, and automated notification systems."
        />
        <meta
          name="keywords"
          content="company announcement technology, corporate communications, investor relations software, business announcements, regulatory filings, corporate disclosure, shareholder communications, SEC filings, press release distribution, automated notifications"
        />
      </Helmet>
      <div className="mk-announcement-container">
        <main className="mk-main-content">
          <div className="mk-announcement-container">
            <main className="mk-main-content">
              <section className="mk-teaser-section">
                <div className="mk-teaser-header">
                  <h3 className="mk-teaser-title">What to Expect</h3>
                  <p className="mk-teaser-subtitle">
                    Our upcoming release will revolutionize how businesses
                    leverage technology
                  </p>
                </div>

                <div className="mk-teaser-content-wrapper">
                  <div className="mk-teaser-intro">
                    <p>
                      The next generation of enterprise software is coming.
                      We've listened to our customers and industry experts to
                      create solutions that address today's challenges while
                      anticipating tomorrow's needs.
                    </p>
                  </div>

                  <div className="mk-teaser-grid">
                    <div className="mk-teaser-card mk-teaser-card-1">
                      <div className="mk-teaser-icon">🚀</div>
                      <h4 className="mk-teaser-card-title">
                        Cutting-Edge Technology
                      </h4>
                      <p className="mk-teaser-card-description">
                        Revolutionary software solutions that will transform how
                        businesses operate, with performance improvements of up
                        to 70%.
                      </p>
                      <ul className="mk-teaser-features">
                        <li>Real-time data processing</li>
                        <li>Advanced machine learning algorithms</li>
                        <li>Seamless third-party integrations</li>
                      </ul>

                      <div className="mk-teaser-stats">
                        <div className="mk-stat-item">
                          <span className="mk-stat-number">70%</span>
                          <span className="mk-stat-label">
                            Faster Processing
                          </span>
                        </div>
                        <div className="mk-stat-item">
                          <span className="mk-stat-number">24/7</span>
                          <span className="mk-stat-label">
                            Real-time Analytics
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="mk-teaser-card mk-teaser-card-2">
                      <div className="mk-teaser-icon">🤖</div>
                      <h4 className="mk-teaser-card-title">AI Integration</h4>
                      <p className="mk-teaser-card-description">
                        Next-generation artificial intelligence capabilities
                        built into our platform for predictive analytics and
                        automation.
                      </p>
                      <ul className="mk-teaser-features">
                        <li>Intelligent process automation</li>
                        <li>Predictive analytics dashboard</li>
                        <li>Natural language processing</li>
                      </ul>

                      <div className="mk-teaser-demo">
                        <h5>See AI in Action</h5>
                        <p>
                          Experience how our AI can predict market trends with
                          95% accuracy
                        </p>
                      </div>
                    </div>

                    <div className="mk-teaser-card mk-teaser-card-3">
                      <div className="mk-teaser-icon">🌐</div>
                      <h4 className="mk-teaser-card-title">
                        Global Accessibility
                      </h4>
                      <p className="mk-teaser-card-description">
                        Cloud-based solutions accessible from anywhere in the
                        world, with enterprise-grade security and reliability.
                      </p>
                      <ul className="mk-teaser-features">
                        <li>Multi-region cloud deployment</li>
                        <li>99.9% uptime guarantee</li>
                        <li>Multi-language support</li>
                      </ul>

                      <div className="mk-teaser-regions">
                        <h5>Now Available In</h5>
                        <div className="mk-region-tags">
                          <span className="mk-region-tag">America</span>
                          <span className="mk-region-tag">Europe</span>
                          <span className="mk-region-tag">Asia</span>
                          <span className="mk-region-tag">Middle East</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mk-teaser-additional">
  <div className="mk-additional-feature">
    <div className="mk-additional-icon">🔒</div>
    <div className="mk-additional-content">
      <h4>Enhanced Security Protocols</h4>
      <p>
        Multi-layered security with biometric authentication
        and end-to-end encryption. Our zero-trust architecture ensures
        complete data protection with military-grade encryption standards.
      </p>
      <ul className="mk-additional-feature-list">
        <li>Biometric and multi-factor authentication</li>
        <li>End-to-end encryption for all data transactions</li>
        <li>Regular security audits and penetration testing</li>
        <li>Real-time threat detection and response system</li>
      </ul>
    </div>
  </div>

  <div className="mk-additional-feature">
    <div className="mk-additional-icon">📊</div>
    <div className="mk-additional-content">
      <h4>Advanced Reporting Suite</h4>
      <p>
        Customizable dashboards with real-time analytics and
        export capabilities. Generate detailed reports with visualizations
        that help you make data-driven decisions instantly.
      </p>
      <ul className="mk-additional-feature-list">
        <li>Drag-and-drop dashboard customization</li>
        <li>Real-time data visualization</li>
        <li>Export to PDF, Excel, and CSV formats</li>
        <li>Scheduled automated report generation</li>
      </ul>
    </div>
  </div>

  <div className="mk-additional-feature">
    <div className="mk-additional-icon">🔄</div>
    <div className="mk-additional-content">
      <h4>Automated Workflows</h4>
      <p>
        Streamline operations with customizable automation
        rules. Reduce manual tasks by up to 80% with our intelligent
        workflow automation system.
      </p>
      <ul className="mk-additional-feature-list">
        <li>Visual workflow builder with no-code options</li>
        <li>Condition-based automation triggers</li>
        <li>Integration with third-party applications</li>
        <li>Performance analytics for workflow optimization</li>
      </ul>
    </div>
  </div>

  <div className="mk-additional-feature">
    <div className="mk-additional-icon">🤝</div>
    <div className="mk-additional-content">
      <h4>Seamless Collaboration</h4>
      <p>
        Enable teams to work together efficiently regardless of location.
        Real-time co-editing, comments, and task assignment features.
      </p>
      <ul className="mk-additional-feature-list">
        <li>Real-time document collaboration</li>
        <li>Team communication channels</li>
        <li>Task assignment and progress tracking</li>
        <li>Version history and change tracking</li>
      </ul>
    </div>
  </div>

  <div className="mk-additional-feature">
    <div className="mk-additional-icon">📱</div>
    <div className="mk-additional-content">
      <h4>Mobile Accessibility</h4>
      <p>
        Access all features on-the-go with our fully responsive
        mobile applications for iOS and Android devices.
      </p>
      <ul className="mk-additional-feature-list">
        <li>Native iOS and Android applications</li>
        <li>Offline functionality for critical tasks</li>
        <li>Mobile-optimized interface</li>
        <li>Push notifications for important updates</li>
      </ul>
    </div>
  </div>

  <div className="mk-additional-feature">
    <div className="mk-additional-icon">🌍</div>
    <div className="mk-additional-content">
      <h4>Global Compliance</h4>
      <p>
        Stay compliant with international regulations across
        all regions with our built-in compliance frameworks.
      </p>
      <ul className="mk-additional-feature-list">
        <li>GDPR, CCPA, and privacy regulation compliance</li>
        <li>Industry-specific compliance templates</li>
        <li>Automated compliance reporting</li>
        <li>Regular updates for changing regulations</li>
      </ul>
    </div>
  </div>

  <div className="mk-additional-feature">
    <div className="mk-additional-icon">⚡</div>
    <div className="mk-additional-content">
      <h4>High Performance</h4>
      <p>
        Experience blazing-fast performance even with large datasets
        and complex operations through our optimized architecture.
      </p>
      <ul className="mk-additional-feature-list">
        <li>Load balancing across multiple servers</li>
        <li>Advanced caching mechanisms</li>
        <li>Database query optimization</li>
        <li>Content delivery network integration</li>
      </ul>
    </div>
  </div>

  <div className="mk-additional-feature">
    <div className="mk-additional-icon">🛠️</div>
    <div className="mk-additional-content">
      <h4>Custom Development</h4>
      <p>
        Tailor the platform to your specific business needs with
        our custom development and white-label solutions.
      </p>
      <ul className="mk-additional-feature-list">
        <li>Custom module development</li>
        <li>API access for extended functionality</li>
        <li>White-labeling options</li>
        <li>Dedicated development team support</li>
      </ul>
    </div>
  </div>

  <div className="mk-additional-feature">
    <div className="mk-additional-icon">🌱</div>
    <div className="mk-additional-content">
      <h4>Sustainable Technology</h4>
      <p>
        Environmentally conscious solutions with energy-efficient
        infrastructure and carbon footprint reduction initiatives.
      </p>
      <ul className="mk-additional-feature-list">
        <li>Energy-efficient data centers powered by renewable energy</li>
        <li>Carbon emission tracking and reporting tools</li>
        <li>Paperless workflow optimization</li>
        <li>Green hosting and sustainable infrastructure options</li>
      </ul>
    </div>
  </div>
</div>
                </div>
              </section>

              <section className="mk-announcement-section">
                <div className="mk-announcement-card mk-card-float">
                  <h3 className="mk-card-title">New Product Launch</h3>
                  <p className="mk-card-content">
                    We're thrilled to announce the release of our revolutionary
                    AI-powered analytics platform, designed to transform how
                    businesses leverage their data for strategic
                    decision-making.
                  </p>
                </div>

                <div className="mk-announcement-card mk-card-float">
                  <h3 className="mk-card-title">Office Expansion</h3>
                  <p className="mk-card-content">
                    MK eTech is expanding to new locations! Our new regional
                    offices will open in New York and Singapore to better serve
                    our global clients with localized support.
                  </p>
                </div>

                <div className="mk-announcement-card mk-card-float">
                  <h3 className="mk-card-title">Partnership Program</h3>
                  <p className="mk-card-content">
                    We've launched a new partner program to collaborate with
                    innovative tech companies worldwide. Join us in shaping the
                    future of IT solutions.
                  </p>
                </div>
              </section>

<section className="mk-feature-section">
  <h2 className="mk-section-title">What's New</h2>
  <div className="mk-feature-grid">
    <div className="mk-feature-item-company mk-feature-glow">
      <div className="mk-feature-icon">🚀</div>
      <h4>Enhanced Performance</h4>
      <p>
        Our latest update delivers 40% faster processing speeds
        and reduced latency with optimized algorithms and improved caching.
      </p>
      <div className="mk-feature-badge">Performance Boost</div>
    </div>
    
    <div className="mk-feature-item-company mk-feature-glow">
      <div className="mk-feature-icon">🔒</div>
      <h4>Advanced Security</h4>
      <p>
        New security protocols with end-to-end encryption to
        protect your sensitive data and prevent unauthorized access.
      </p>
      <div className="mk-feature-badge">Security Update</div>
    </div>
    
    <div className="mk-feature-item-company mk-feature-glow">
      <div className="mk-feature-icon">🌐</div>
      <h4>Global Support</h4>
      <p>
        24/7 support team now available worldwide with response
        time under 15 minutes and multilingual assistance.
      </p>
      <div className="mk-feature-badge">Support Expansion</div>
    </div>
    
    <div className="mk-feature-item-company mk-feature-glow">
      <div className="mk-feature-icon">🤖</div>
      <h4>AI-Powered Insights</h4>
      <p>
        New machine learning algorithms provide predictive analytics
        and intelligent recommendations for your business decisions.
      </p>
      <div className="mk-feature-badge">AI Enhancement</div>
    </div>
    
    <div className="mk-feature-item-company mk-feature-glow">
      <div className="mk-feature-icon">📊</div>
      <h4>Advanced Analytics</h4>
      <p>
        Comprehensive data visualization tools with custom reporting
        and real-time dashboard capabilities for better insights.
      </p>
      <div className="mk-feature-badge">New Feature</div>
    </div>
    
    <div className="mk-feature-item-company mk-feature-glow">
      <div className="mk-feature-icon">🔄</div>
      <h4>Seamless Integration</h4>
      <p>
        Connect with popular third-party tools and platforms through
        our expanded API library and pre-built connectors.
      </p>
      <div className="mk-feature-badge">Integration Update</div>
    </div>
    
    <div className="mk-feature-item-company mk-feature-glow">
      <div className="mk-feature-icon">📱</div>
      <h4>Mobile Experience</h4>
      <p>
        Redesigned mobile application with offline capabilities
        and enhanced touch interface for on-the-go productivity.
      </p>
      <div className="mk-feature-badge">Mobile Upgrade</div>
    </div>
    
    <div className="mk-feature-item-company mk-feature-glow">
      <div className="mk-feature-icon">🌍</div>
      <h4>Global Expansion</h4>
      <p>
        Now available in 15 new countries with localized content
        and regional compliance features for international businesses.
      </p>
      <div className="mk-feature-badge">Global Reach</div>
    </div>
    
    <div className="mk-feature-item-company mk-feature-glow">
      <div className="mk-feature-icon">⚡</div>
      <h4>Instant Deployment</h4>
      <p>
        New one-click deployment options with automated setup
        and configuration for faster implementation.
      </p>
      <div className="mk-feature-badge">Deployment Improvement</div>
    </div>
  </div>
  
  <div className="mk-feature-stats">
    <div className="mk-feature-stat-item">
      <span className="mk-stat-number">500+</span>
      <span className="mk-stat-label">New Features</span>
    </div>
    <div className="mk-feature-stat-item">
      <span className="mk-stat-number">99.9%</span>
      <span className="mk-stat-label">Uptime</span>
    </div>
    <div className="mk-feature-stat-item">
      <span className="mk-stat-number">40%</span>
      <span className="mk-stat-label">Faster Performance</span>
    </div>
    <div className="mk-feature-stat-item">
      <span className="mk-stat-number">15</span>
      <span className="mk-stat-label">New Countries</span>
    </div>
  </div>
  
  <div className="mk-teaser-cta">
    <h3>Ready to Transform Your Business?</h3>
    <p>
      Join our exclusive early access program and be among the
      first to experience these innovations with personalized onboarding.
    </p>
    <div className="mk-teaser-buttons">
      <a href="/contact-us">
        <button className="mk-cta-primary">Contact Us</button>
      </a>
    </div>
  </div>
</section>
            </main>
          </div>
        </main>
      </div>
      <Testimonial />

      <div className="tech-slider-container" ref={containerRef}>
        <h2 className="tech-slider-title">Tools & Tech Stack</h2>
        <div className="tech-slider-divider"></div>

        {/* First row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row1Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow1.map((tech, index) => (
              <div key={`row1-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Second row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row2Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow2.map((tech, index) => (
              <div key={`row2-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyAnnouncement;
